import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=09840ff5&scoped=true"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"
import style0 from "./Clock.vue?vue&type=style&index=0&id=09840ff5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09840ff5",
  null
  
)

export default component.exports